import React from 'react'
import { SVGProps } from 'react'

const MailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.4721 3.5695C15.4069 3.13393 15.1879 2.73613 14.8546 2.44819C14.5214 2.16026 14.096 2.00125 13.6556 2H2.34458C1.90417 2.00125 1.47878 2.16026 1.14553 2.44819C0.812283 2.73613 0.593228 3.13393 0.528076 3.5695L8.00008 8.4045L15.4721 3.5695Z" />
    <path d="M8.2715 9.41993C8.19061 9.47224 8.09633 9.50007 8 9.50007C7.90367 9.50007 7.80939 9.47224 7.7285 9.41993L0.5 4.74293V12.1554C0.500529 12.6445 0.69503 13.1133 1.04083 13.4591C1.38662 13.8049 1.85547 13.9994 2.3445 13.9999H13.6555C14.1445 13.9994 14.6134 13.8049 14.9592 13.4591C15.305 13.1133 15.4995 12.6445 15.5 12.1554V4.74243L8.2715 9.41993Z" />
  </svg>
)
export default MailIcon
